/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { SFondsPlanInfo } from './SFondsPlanInfo';

/**
 * Additional data about the amount field
 */
export type AmountFieldAdditionalData = {
    sFondsPlanInfo?: SFondsPlanInfo;
    /**
     * Indicator of whether the payment is a DigiVv top up
     */
    digiVvTopUp?: boolean;
    authorizationType?: AmountFieldAdditionalData.authorizationType;
};

export namespace AmountFieldAdditionalData {

    export enum authorizationType {
        TAC = 'TAC',
        TAN = 'TAN',
        SID = 'SID',
        CARDTAN = 'CARDTAN',
        GEORGE_TOKEN = 'GEORGE_TOKEN',
        UNKNOWN = 'UNKNOWN',
    }


}

